import { combineReducers } from "redux";
import { authReducer } from "./auth";
import { settingsReducer } from "./settings";

export const reducers = combineReducers({
  auth: authReducer,
  settings: settingsReducer,
});
